// extracted by mini-css-extract-plugin
export var actions = "_r4-4";
export var item = "_r4-1";
export var price = "_r4-3";
export var quantity = "_r4-2";
export var table = "_r4-0";